import React from 'react';
import { List, ListItem, ListItemButton, ListItemText, Typography } from '@mui/material';
import { abyssColors } from '@/theme/colors';
import { FilterField } from './InsightsSearchBar.types';
import { VISIBLE_DROPDOWN_ITEMS } from './constants';

interface FilterFieldsListProps {
  fields: FilterField[];
  onFieldSelect: (fieldId: string, fieldName: string) => void;
}

export const FilterFieldsList = ({ fields, onFieldSelect }: FilterFieldsListProps) => {
  return (
    <>
      <Typography
        variant="subtitle2"
        sx={{ px: 1, py: 0.5, mb: 0.5, color: abyssColors.primary[400], fontSize: '1.2rem' }}
      >
        Suggestions
      </Typography>
      <List dense disablePadding>
        {fields.length === 0 && (
          <ListItem>
            <ListItemText primary="No filters found" />
          </ListItem>
        )}
        {fields.slice(0, VISIBLE_DROPDOWN_ITEMS).map((field) => {
          return (
            <ListItem key={field.id} disablePadding>
              <ListItemButton
                onClick={() => onFieldSelect(field.id, field.templateField?.key ?? field.name)}
              >
                <ListItemText primary={field.name} />
              </ListItemButton>
            </ListItem>
          );
        })}
      </List>
    </>
  );
};
